import { TabProxy } from "encampy";

export async function automateNJLogin(
  tab: TabProxy,
  username: string,
  password: string
): Promise<void> {
  // Wait for the login page to load
  await tab.waitForElement("input#IDToken1", { timeout: 10000 });

  // Type in the username
  await tab.type("input#IDToken1", username);

  // Type in the password
  await tab.type("input#IDToken2", password);

  // Submit the login form
  await tab.submit("form[name='Login']");

  // Wait for navigation to complete after login
  await tab.waitForNavigation({ timeout: 10000 });
}
